// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"ze","categoryName":"Ae","categoryImage":"Be","categoryContent":"Ce","bottomAligned":"De"};